import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import type { AdditionalAnalyticAttributes } from '@atlassian/conversation-assistant-message-actions-api/types';
import type { ConversationResultAttributionContext } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import type { MessageSource } from './types';

type ApplyResultAttributionContextParams = {
	resultAttributionContext?: ConversationResultAttributionContext;
	routingAgentId: string;
	messageSources?: Partial<MessageSource>;
	additionalAnalyticAttributes?: AdditionalAnalyticAttributes;
};

type ResultAttributionAnalytics = {
	messageSources?: Partial<MessageSource>;
	additionalAnalyticAttributes?: AdditionalAnalyticAttributes;
	shouldClearResultAttributionContext?: boolean;
};

export const applyResultAttributionContext = ({
	resultAttributionContext,
	routingAgentId,
	messageSources,
	additionalAnalyticAttributes,
}: ApplyResultAttributionContextParams): ResultAttributionAnalytics => {
	const sourceAgentId = resultAttributionContext?.sourceAgentId;
	const launchSource = resultAttributionContext?.launchSource;
	const entryPoint = isExperimentEnabled('cc_contextual_agent_creation_v2')
		? resultAttributionContext?.entryPoint
		: undefined;

	if (
		resultAttributionContext === undefined ||
		(launchSource === undefined && entryPoint === undefined)
	) {
		return { messageSources, additionalAnalyticAttributes };
	}

	if (sourceAgentId !== undefined && sourceAgentId !== routingAgentId) {
		return {
			messageSources,
			additionalAnalyticAttributes,
			shouldClearResultAttributionContext: true,
		};
	}

	const attributedMessageSources = {
		...(messageSources ?? {}),
		...(launchSource !== undefined && messageSources?.followUpSource === undefined
			? { followUpSource: launchSource }
			: {}),
		...(entryPoint !== undefined && messageSources?.entryPoint === undefined ? { entryPoint } : {}),
	};
	const attributedAdditionalAnalyticAttributes = launchSource
		? {
				launchSource,
				...(additionalAnalyticAttributes ?? {}),
			}
		: additionalAnalyticAttributes;

	return {
		messageSources: attributedMessageSources,
		additionalAnalyticAttributes: attributedAdditionalAnalyticAttributes,
	};
};
